import {
  CalendarClock, Clock3, LayoutGrid, BellRing, UserRound, ShieldCheck,
  BarChart3, Plug, Bot, Sparkles, MailCheck, TrendingUp, Smartphone,
  Zap, Utensils, Wine, PartyPopper, Building2, Hotel,
  Ban, Wallet, Receipt, Headphones, Globe, MessageCircle, Rocket, Share2,
  Star, ArrowRight, Check, HelpCircle, Settings, Lock, Eye, Heart
} from 'lucide-react';

const ICON_MAP = {
  CalendarClock, Clock3, LayoutGrid, BellRing, UserRound, ShieldCheck,
  BarChart3, Plug, Bot, Sparkles, MailCheck, TrendingUp, Smartphone,
  Zap, Utensils, Wine, PartyPopper, Building2, Hotel,
  Ban, Wallet, Receipt, Headphones, Globe, MessageCircle, Rocket, Share2,
  Star, ArrowRight, Check, HelpCircle, Settings, Lock, Eye, Heart,
};

/** Resolve an icon name string to a lucide-react component. Falls back to Zap. */
export default function getIcon(name) {
  if (!name || typeof name !== 'string') return Zap;
  return ICON_MAP[name] || Zap;
}

export const ICON_NAMES = Object.keys(ICON_MAP);
